@if (tabs && tabs.length && !searching) {
  <icc-tabs [tabs]="availableTabs" [activeTabIndex]="getSelectedTab()"
  (activated)="selectTab($event)" [class.icc-tabs_tab--hide]="tabs.length === 1 && hideSingleTab"></icc-tabs>
}

@if (scrollable) {
  <div class="scroller-wrapper" #scroller (scroll)="onScroll()" [class.scroller-wrapper--no-tabs]="!tabs || !tabs.length || !searching || tabs.length === 1 && hideSingleTab">
    <virtual-scroller #scroll [parentScroll]="scroller" [items]="filteredItems$ | async"
      [enableUnequalChildrenSizes]="true">
      <div class="icc-list" #container [ngClass]="getItemHeightAndWidthClass()">
        @for (item of scroll.viewPortItems; track trackByFunction($index, item)) {
          <div class="icc-list-item"
            [class.icc-list-item--selected]="isSelectedId(item.id)" [class.icc-list-item--disabled]="item.disabled" [matRippleDisabled]="item.disabled" (click)="onSelect(item)" matRipple
            [class.icc-list-item--color]="itemTemplate === 'itemColor'">
            <ng-container [ngTemplateOutlet]="itemTemplateDef" [ngTemplateOutletContext]="{ iccListItem: item }">
            </ng-container>
          </div>
        }
      </div>
    </virtual-scroller>
  </div>
}

@if (!scrollable) {
  <div class="icc-list" [class.no-scrollable]="!scrollable" [ngClass]="getItemHeightAndWidthClass()">
    @for (item of (filteredItems$ | async); track item) {
      <div class="icc-list-item"
        [class.icc-list-item--selected]="isSelectedId(item.id)" [class.icc-list-item--disabled]="item.disabled" [matRippleDisabled]="item.disabled" (click)="onSelect(item)" matRipple
        [class.icc-list-item--color]="itemTemplate === 'itemColor'">
        <ng-container [ngTemplateOutlet]="itemTemplateDef" [ngTemplateOutletContext]="{ iccListItem: item }">
        </ng-container>
      </div>
    }
  </div>
}

<ng-template #itemColor let-item="iccListItem">
  <div class="item-color">
    <div
      class="item-color-fill"
      [style.backgroundColor]="item.color"
      [style.backgroundImage]="'url(' + item.imageUrl + ')'"
    ></div>
    @if (item.showInfo) {
      <button mat-mini-fab class="item-color-info-button" (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
        <mat-icon class="mat-18">info</mat-icon>
      </button>
    }
    @if (item.editGlazing) {
      <button mat-mini-fab class="item-color-glazing-button" (click)="clickEditGlazingButton(item)" color="secondary" [title]="item.description">
        <mat-icon class="mat-18">build</mat-icon>
      </button>
    }
    <p class="item-color-title">{{item.title}}</p>
  </div>
</ng-template>

<ng-template #itemImgTitleDescription let-item="iccListItem">
  <div class="item-imgTitleDescription" [ngClass]="vertical ? 'item-imgTitleDescription--vertical ' : ''">
    <p class="item-imgTitleDescription-title">{{item.title}}</p>
    <div class="icc-list-item-img-container">
      <img class="item-imgTitleDescription-img" [src]="item.imageUrl" [alt]="item.title" defaultImg>
    </div>
    <div [innerHTML] = "item.description" class="item-imgTitleDescription-description">{{item.description}}</div>
    @if (item.showInfo ) {
      <button mat-mini-fab class="item-imgTitleDescription-info-button mat-elevation-z0" (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
        <mat-icon class="mat-18">info</mat-icon>
      </button>
    }
    @if (item.editGlazing) {
      <button mat-mini-fab class="item-imgTitleDescription-glazing-button mat-elevation-z0" (click)="clickEditGlazingButton(item)" color="secondary" [title]="item.description">
        <mat-icon class="mat-18">build</mat-icon>
      </button>
    }
  </div>
</ng-template>

<ng-template #mountingMethod let-item="iccListItem">
  <div class="item-imgTitleDescription">
    <div class="icc-list-item-img-container">
      <img class="item-imgTitleDescription-img" [src]="item.img" [alt]="item.name" defaultImg>
    </div>
    <p class="item-imgTitleDescription-title">{{item.name}}</p>
    <div [innerHTML] = "''" class="item-imgTitleDescription-description">{{item.description}}</div>
  </div>
</ng-template>

<ng-template #itemImgTitle let-item="iccListItem">
  @if (item?.errorMessages && item?.errorMessages?.length ) {
    <div class='errorMessage'>
      @for (message of item?.errorMessages; track message) {
        <p>
          {{message}}
        </p>
      }
    </div>
  }
  <div class="item-imgTitle" [ngClass]="item.disabled ? 'item-imgTitle-disable' : ''">
    <div class="icc-list-item-img-container">
      <img class="item-imgTitle-img" [src]="item.imageUrl" [alt]="item.title" defaultImg>
    </div>
    <p class="item-imgTitle-title">{{item.title}}</p>
    @if (item.shortDescription) {
      <p class="item-imgTitle-short_description">{{item.shortDescription}}</p>
    }
    @if (item.showInfo ) {
      <button mat-mini-fab class="item-itemImgTitle-info-button mat-elevation-z0" (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
        <mat-icon class="mat-18">info</mat-icon>
      </button>
    }
    @if (item.editGlazing) {
      <button mat-mini-fab class="item-itemImgTitle-glazing-button" (click)="clickEditGlazingButton(item)" color="secondary" [title]="item.description">
        <mat-icon class="mat-18">build</mat-icon>
      </button>
    }
  </div>
  @if (item.infoBox && item.infoBox.show) {
    <div class="item-info">
      <p class="item-info-options">{{item.infoBox.title}}</p>
      <p class="item-info-size">{{item.infoBox.size}}</p>
      <p class="item-info-size">{{item.infoBox.system}}</p>
    </div>
  }
</ng-template>
<ng-template #itemOnlyTitle let-item="iccListItem">
  <div class="item-onlyTitle">
    <p class="item-onlyTitle-title">{{item.title}}</p>
  </div>
</ng-template>

